import { LOCATION_PROVINCE } from '../../routes';
import customAxios from "../../customAxios";
import {locationNamespace} from "../../../types/location.namespace";

async function updateProvince(_id: string, props: locationNamespace.province.update) {
  try {
    return (await customAxios.patch(`${LOCATION_PROVINCE}/${_id}`, props)).data;
  } catch (error: any) {
    console.error({LOCATION_PROVINCE: error});
  }
}

export default updateProvince;
